import React, { useEffect, useState } from "react";

import Container from "@mui/material/Container";
import Alert from "@mui/material/Alert";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useNavigate } from "react-router-dom";

import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";

import Link from "@mui/material/Link";

import { Menu, MenuItem } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";

import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Grid from "@mui/material/Grid";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import isEmpty from "lodash-es/isEmpty";
import Select from "react-select";

import MuiMenuItem from "@mui/material/MenuItem";
import MuiSelect from "@mui/material/Select";

import InputLabel from "@mui/material/InputLabel";
import Button from "@mui/material/Button";
import NumericInput from "react-numeric-input";

import TextField from "@mui/material/TextField";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";

import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";

import { doService } from "../../services/ServiceHelper";
import TeachersSelector from "../../components/faculty/report/TeachersSelector";
import { getMonday, addDaysStr } from "../../services/DateService";
import TableRowNoResults from "../../components/TableRowNoResults";

import { paddy } from "../../services/StringService";
import { getSchoolTeachers, getLocations } from "../../services/SchoolService";
import { getSchoolStudents } from "../../services/UserService";

import { showErrorMulti, showToast } from "../../components/ATPDialogs";
import { getTeacherUserLists } from "../../services/UserService";
import {
  getEventTypes,
  getTeacherEvents,
  saveEvent,
  getSchoolEvent,
  deleteSchoolEvent,
  getEventStartTime,
  getEventEndTime,
} from "../../services/EventService";
import {
  StripedTableCell,
  StripedTableRow,
} from "../../components/StripedTable";
import { Divider } from "@mui/material";
import clone from "lodash-es/clone";
import { getPassTypes } from "../../services/PassService";

// for time picker
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("America/New_York");

const ManageEvents = () => {
  const navigate = useNavigate();

  const ALL_STUDENTS = { label: "-- ALL STUDENTS --", value: "A" };
  const SELECTED_STUDENTS = {
    label: "Selected Students (Specify Below)",
    value: "S",
  };

  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [showProgress, setShowProgress] = useState(false);

  const [_open, setOpen] = useState(false);

  const [_eventDate, setEventDate] = React.useState(dayjs());
  const [_startTime, setStartTime] = React.useState(null);
  const [_endTime, setEndTime] = React.useState(null);
  const [_title, setTitle] = React.useState("");
  const [_selectedEventType, setSelectedEventType] = React.useState({
    title: "-- SELECT --",
    value: null,
    eid: null,
  });
  const [_description, setDescription] = React.useState("");
  const [_selectedStudents, setSelectedStudents] = useState([]);
  const [_selectedTeachers, setSelectedTeachers] = useState([]);
  const [_selectedIndex, setSelectedIndex] = React.useState(0);

  const [_allEvents, setAllEvents] = useState([]);
  const [_allEventTypes, setAllEventTypes] = useState([]);
  const [_allTeachers, setAllTeachers] = useState([]);
  const [_allStudents, setAllStudents] = useState([]);

  const [_selectedEventEid, setSelectedEventEid] = useState(null);

  const [_whoCanView] = useState([ALL_STUDENTS, SELECTED_STUDENTS]);
  const [_selectedWhoCanView, setSelectedWhoCanView] = useState(_whoCanView[0]);
  const [_allUserLists, setAllUserLists] = useState([]);
  const [_selectedUserLists, setSelectedUserLists] = useState(null);
  const [_autoSignup, setAutoSignup] = useState(false);
  const [_allowSignup, setAllowSignup] = useState(false);
  const [_allLocations, setAllLocations] = useState([]);
  const [_selectedLocation, setSelectedLocation] = useState(null);
  const [_maxStudents, setMaxStudents] = useState(100);
  const [_passTypes, setPassTypes] = useState([]);
  const [_passType, setPassType] = useState("XX");
  const [_createPasses, setCreatePasses] = useState(false);

  useEffect(() => {
    initEventMeta();
    initEvents();
    initTeachers();
    initStudents();
    initPassTypes();
  }, []);

  const initPassTypes = () => {
    doService(getPassTypes(_school, _jwt), (result) => {
      setPassTypes(result.data);
    });
  };

  const initEvents = () => {
    setShowProgress(true);

    const startDate = getMonday();
    const endDate = addDaysStr(startDate, 270);

    doService(getTeacherEvents(_school, _jwt, startDate, endDate), (result) => {
      setAllEvents(result.data);
      setShowProgress(false);
    });
  };

  const initTeachers = () => {
    doService(getSchoolTeachers(_school, _jwt), (results) => {
      setAllTeachers(results.data);
    });
  };

  const initStudents = () => {
    doService(getSchoolStudents(_school, _jwt), (results) => {
      const newStudents = [];

      for (let student of results.data) {
        newStudents.push({
          label: `${student.last_name}, ${student.first_name}`,
          value: student.eid,
        });
      }
      setAllStudents(newStudents);
    });
  };

  const initEventMeta = () => {
    doService(getEventTypes(_school, _jwt), (result) => {
      const newEventTypes = [];
      for (let type of result.data) {
        const cloneType = clone(type);
        cloneType.label = cloneType.name;
        cloneType.value = cloneType.eid;
        newEventTypes.push(cloneType);
      }
      setAllEventTypes(newEventTypes);
    });

    doService(getTeacherUserLists(_school, _jwt), (result) => {
      const entries = [];
      for (const entry of result.data) {
        entries.push({
          label: entry.name,
          value: entry.eid,
        });
      }
      setAllUserLists(entries);
      return entries;
    });

    doService(getLocations(_school, _jwt), (result) => {
      const locations = [];
      locations.push({
        label: "-- NONE --",
        value: "XX",
      });
      for (const entry of result.data) {
        locations.push({
          label: entry.name,
          value: entry.eid,
        });
      }
      setAllLocations(locations);
      return locations;
    });
  };

  const onClickCreate = () => {
    setSelectedIndex(0);
    setSelectedEventEid(null);
    setTitle("");
    setStartTime(null);
    setEndTime(null);
    setSelectedEventType({
      title: "-- SELECT --",
      eid: null,
      value: null,
      label: "-- SELECT --",
    });
    setSelectedStudents(null);
    setSelectedTeachers(null);
    setSelectedUserLists(null);
    setDescription("");
    setAutoSignup(false);
    setSelectedWhoCanView(_whoCanView[0]);
    setOpen(true);
    setSelectedLocation(null);
    setMaxStudents(100);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const validateValues = () => {
    const dialogTitle = "Unable to Save";
    const messages = [];

    if (isEmpty(_title)) {
      messages.push("Please enter a Title");
    }

    if (_startTime == null) {
      messages.push("Please select a Start Time");
    }
    if (_endTime == null) {
      messages.push("Please select an End Time");
    }

    // check before/after times
    if (_startTime != null && _endTime != null) {
      if (!isStartTimeBefore()) {
        messages.push("End Time must occur after Start Time");
      }
    }

    if (_selectedEventType.eid === null) {
      messages.push("Enter an Event Type");
    }

    if (_createPasses === true && _passType === "XX") {
      messages.push("Please select a Pass Type");
    }

    if (messages.length > 0) {
      showErrorMulti(dialogTitle, messages, () => {
        setOpen(true);
      });
    }

    return messages.length === 0;
  };

  const isStartTimeBefore = () => {
    const timeDiff = _endTime.diff(_startTime, "minute");
    return timeDiff > 0;
  };

  const getSelectedTeacherEids = () => {
    const eids = [];
    for (let selectedTeacher of _selectedTeachers) {
      eids.push(selectedTeacher.value);
    }
    return eids;
  };

  const getSelectedUserListEids = () => {
    const eids = [];
    for (let selectedUserList of _selectedUserLists) {
      eids.push(selectedUserList.value);
    }
    return eids;
  };

  const getSelectedStudentEids = () => {
    const eids = [];
    if (_selectedStudents != null) {
      for (let selectedStudent of _selectedStudents) {
        eids.push(selectedStudent.value);
      }
    }
    return eids;
  };

  const onClickSave = () => {
    setOpen(false);
    if (!validateValues()) {
      return;
    }

    let selectedTeachers = [];
    if (_selectedTeachers != null) {
      selectedTeachers = getSelectedTeacherEids();
    }

    let selectedUserLists = [];
    if (_selectedUserLists != null) {
      selectedUserLists = getSelectedUserListEids();
    }

    const startHour = dayjs(_startTime).hour();
    const startMinute = dayjs(_startTime).minute();
    const endHour = dayjs(_endTime).hour();
    const endMinute = dayjs(_endTime).minute();

    let selectedLocation = _selectedLocation;
    if (selectedLocation === "XX" || selectedLocation == null) {
      selectedLocation = null;
    } else {
      selectedLocation = selectedLocation.value;
    }

    const passTypeEid = _createPasses === true && _passType !== "XX" ? _passType : null;

    doService(
      saveEvent(
        _school,
        _jwt,
        _selectedEventEid,
        _title,
        getSelectedStudentEids(),
        _eventDate,
        startHour,
        startMinute,
        endHour,
        endMinute,
        _selectedEventType.value,
        selectedTeachers,
        _description,
        selectedUserLists,
        _allowSignup ? "Y" : "N",
        _autoSignup ? "Y" : "N",
        _selectedWhoCanView.value,
        selectedLocation,
        _maxStudents,
        passTypeEid
      ),
      (result) => {
        showToast("S", "Event Saved!");
        initEvents();
      },
    );
  };

  const onChangeTitle = (event) => setTitle(event.target.value);
  const handleChangeDescription = (event) => setDescription(event.target.value);
  const onChangeEventType = (obj) => {
    setSelectedEventType(obj);
  };

  const onSelectTeachers = (teacherEids) => {
    setSelectedTeachers(teacherEids);
  };

  const onTabChange = (event, index) => setSelectedIndex(index);

  const onDateClick = (event) => {
    loadEvent(event.eid);
  };

  const getTypeOption = (eid) => {
    for (let entry of _allEventTypes) {
      if (entry.value === eid) {
        return entry;
      }
    }
    return null;
  };

  const getUserListOptions = (selectedUserLists) => {
    const selectedEntries = [];

    for (let entry of _allUserLists) {
      for (let list of selectedUserLists) {
        if (entry.value === list.eid) {
          selectedEntries.push({
            value: entry.eid,
            label: entry.label,
          });
          break;
        }
      }
    }
    return selectedEntries;
  };

  const getMemberOptions = (selectedStudents) => {
    const selectedEntries = [];

    for (let entry of _allStudents) {
      for (let student of selectedStudents) {
        if (entry.eid === student.eid) {
          selectedEntries.push({
            value: entry.eid,
            label: entry.last_name + ", " + entry.first_name,
          });
          break;
        }
      }
    }
    return selectedEntries;
  };

  const getProctorOptions = (selectedProctors) => {
    const selectedEntries = [];

    for (let entry of _allTeachers) {
      for (let teacher of selectedProctors) {
        if (entry.eid === teacher.eid) {
          selectedEntries.push({
            value: entry.eid,
            label: entry.last_name + ", " + entry.first_name,
          });
          break;
        }
      }
    }
    return selectedEntries;
  };

  const loadEvent = (eid) => {
    setShowProgress(true);
    doService(getSchoolEvent(_school, _jwt, eid), (result) => {
      const row = result.data;
      const event = row.event;
      const members = row.members;
      const proctors = row.proctors;
      const userLists = row.userLists;

      setShowProgress(false);
      setSelectedIndex(0);
      setSelectedEventEid(event.eid);
      setTitle(event.title);
      setDescription(event.description);
      setEventDate(dayjs(event.startDate));
      setSelectedEventType(getTypeOption(event.typeEid));
      setSelectedTeachers(getProctorOptions(proctors));
      setSelectedStudents(getMemberOptions(members));
      setStartTime(
        dayjs(buildTime(event.startDate, event.startHour, event.startMinute)),
      );
      setEndTime(
        dayjs(buildTime(event.startDate, event.endHour, event.endMinute)),
      );
      setSelectedUserLists(getUserListOptions(userLists));
      setAllowSignup(event.allowSignup === "Y");
      setAutoSignup(event.autoSignup === "Y");

      setMaxStudents(event.maxAttendance);
      if (event.locationEid != null) {
        setSelectedLocation({
          label: event.locationName,
          value: event.locationEid,
        });
      } else {
        setSelectedLocation({ label: "-- NONE --", value: "XX" });
      }

      let whoCanViewIndex = 0;
      if (event.whoCanView === "S") {
        whoCanViewIndex = 1;
      }
      setSelectedWhoCanView(_whoCanView[whoCanViewIndex]);
      setOpen(true);
    });
  };

  const buildTime = (date, hour, minute) => {
    const result = `${date} ${paddy(hour, 2, "0")}:${paddy(minute, 2, "0")}:00`;
    return result;
  };

  const onClickDelete = (event) => {
    if (!window.confirm("Click OK to Delete Event.")) {
      return;
    }

    setOpen(false);

    doService(deleteSchoolEvent(_school, _jwt, event.eid), (results) => {
      initEvents();
      showToast("S", "Event Deleted!");
    });
  };
  const handleChangeWhoCanView = (obj) => setSelectedWhoCanView(obj);

  const handleChangeUserLists = (objs) => {
    setSelectedUserLists(objs);
  };

  const handleChangeStudents = (objs) => {
    setSelectedStudents(objs);
  };

  const handleChangeLocation = (obj) => {
    setSelectedLocation(obj);
  };

  const handleChangeAutoSignup = (event) => {
    const checked = event.target.checked;
    setAutoSignup(checked);
  };

  const handleChangeAllowSignup = (event) => {
    const checked = event.target.checked;
    setAllowSignup(checked);
  };

  const onClickTakeAttendance = (eid) => {
    navigate(`/faculty/event/${eid}/attendance/take`);
  };

  const onClickEventQR = (eid) => {
    navigate(`/faculty/event/signup/${eid}`);
  };

  const onClickParentQR = (eid) => {
    navigate(`/faculty/event/signup/${eid}`);
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Manage My Events" showBack={true} />
        <ProgressBar showProgress={showProgress} />

        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item sx={6}>
            <Button
              variant="contained"
              onClick={onClickCreate}
              title="Create Event"
            >
              Create Event
            </Button>
          </Grid>
          <Grid item sx={6}></Grid>
        </Grid>
        <br />

        <TableContainer component={Paper} sx={{ mt: 0, mb: 1 }}>
          <Table size="small">
            <TableHead>
              <StripedTableRow>
                <StripedTableCell>Date</StripedTableCell>
                <StripedTableCell>Time</StripedTableCell>
                <StripedTableCell>Title</StripedTableCell>
                <StripedTableCell>Type</StripedTableCell>
                <StripedTableCell>Actions</StripedTableCell>
              </StripedTableRow>
            </TableHead>
            <TableBody>
              <TableRowNoResults data={_allEvents} />
              {_allEvents.map((result) => (
                <StripedTableRow key={result.eid}>
                  <StripedTableCell>
                    <Link
                      className="link-pointer"
                      onClick={() => onDateClick(result)}
                    >
                      {dayjs(result.startDate).format("MM/DD")}
                    </Link>
                  </StripedTableCell>
                  <StripedTableCell>
                    {getEventStartTime(result)} - {getEventEndTime(result)}
                  </StripedTableCell>
                  <StripedTableCell>{result.title}</StripedTableCell>
                  <StripedTableCell>{result.eventTypeName}</StripedTableCell>
                  <StripedTableCell>
                    <Menu menuButton={<Button>Actions</Button>} transition>
                      <MenuItem
                        value={result.eid}
                        onClick={() => onClickTakeAttendance(result.eid)}
                      >
                        Take Attendance
                      </MenuItem>
                      {result.allowSignup === "Y" && (
                        <MenuItem
                          value={result.eid}
                          onClick={() => onClickEventQR(result.eid)}
                        >
                          Student QR Code
                        </MenuItem>
                      )}
                      {result.isGuardianEvent === "Y" && (
                        <MenuItem
                          value={result.eid}
                          onClick={() => onClickParentQR(result.eid)}
                        >
                          Parent QR Code
                        </MenuItem>
                      )}
                      <Divider />
                      <MenuItem
                        value={result.eid}
                        onClick={() => onClickDelete(result)}
                      >
                        Delete
                      </MenuItem>
                    </Menu>
                  </StripedTableCell>
                </StripedTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      <Dialog
        PaperProps={{
          sx: {
            width: 800,
            maxHeight: 750,
          },
        }}
        onClose={handleClose}
        open={_open}
        fullScreen={true}
      >
        <DialogTitle>Manage Event</DialogTitle>

        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 0.0 }}>
            <Grid item xs={4}>
              <InputLabel sx={{ mt: 0 }}>Event Type *</InputLabel>
              <Select
                options={_allEventTypes}
                onChange={onChangeEventType}
                value={_selectedEventType}
              />
            </Grid>{" "}
            <Grid item xs={8}>
              <InputLabel sx={{ mt: 0 }}>Event Title *</InputLabel>
              <TextField
                margin="dense"
                type="text"
                fullWidth
                size="small"
                onChange={onChangeTitle}
                placeholder="Required Field"
                value={_title}
                sx={{ mt: 0 }}
              />
            </Grid>
          </Grid>

          <InputLabel sx={{ mt: 1 }}>Event Date/Times *</InputLabel>
          <Grid container spacing={2} sx={{ mt: 0.0 }}>
            <Grid item xs={4}>
              <DatePicker
                sx={{ mt: 0 }}
                defaultValue={dayjs()}
                value={_eventDate}
                disablePast
                onChange={(newValue) => setEventDate(newValue)}
              />
            </Grid>
            <Grid item xs={4}>
              <TimePicker
                sx={{ mt: 0 }}
                label="Start..."
                value={_startTime}
                timeSteps={{ minutes: 10 }}
                minTime={dayjs().set("hour", 7).set("minute", 0)}
                maxTime={dayjs().set("hour", 15).set("minute", 0)}
                timezone="America/New_York"
                onChange={(newValue) => setStartTime(newValue)}
              />
            </Grid>
            <Grid item xs={4}>
              <TimePicker
                label="End..."
                value={_endTime}
                timeSteps={{ minutes: 10 }}
                minTime={dayjs().set("hour", 7).set("minute", 0)}
                maxTime={dayjs().set("hour", 15).set("minute", 0)}
                timezone="America/New_York"
                onChange={(newValue) => setEndTime(newValue)}
              />
            </Grid>
          </Grid>

          {(_selectedEventType.allowSignup === "Y" ||
            _selectedEventType.autoSignupOnAttendance === "Y") && (
            <FormControlLabel
              sx={{ mt: 2 }}
              control={
                <Checkbox
                  checked={_allowSignup}
                  onChange={(event) => handleChangeAllowSignup(event)}
                />
              }
              label="Allow Students to Sign Themselves Up"
            />
          )}

          {_selectedEventEid != null && (
            <>
              <br />
              <Button
                sx={{ mt: 2 }}
                onClick={() => onClickTakeAttendance(_selectedEventEid)}
                variant="contained"
              >
                Take Attendance
              </Button>
            </>
          )}

          <Tabs value={_selectedIndex} onChange={onTabChange} sx={{ mt: 2 }}>
            <Tab label="Permitted Students" />
            <Tab label="Hall Passes" />
            <Tab label="Details" />
          </Tabs>

          {_selectedIndex === 0 && (
            <Container sx={{ pl: 0 }}>
              <br />

              <Alert severity="warning" sx={{ mb: 1 }}>
                Only these students below will be permitted to sign up for this
                event.
              </Alert>
              <InputLabel sx={{ mt: 1 }}>
                Students Who Can Sign Up for this Event:
              </InputLabel>
              <Select
                options={_whoCanView}
                onChange={handleChangeWhoCanView}
                value={_selectedWhoCanView}
              />

              <br />

              {_selectedWhoCanView.value === "S" && (
                <>
                  <Alert severity="warning" sx={{ mt: 1 }}>
                    You can now select MULTIPLE LISTS. NOTE: they will not
                    populate the list of students below (and that's okay) -
                    we're just capturing the list names themselves.
                  </Alert>

                  <InputLabel sx={{ mt: 1 }}>
                    Select from List (Optional):
                  </InputLabel>
                  <Select
                    options={_allUserLists}
                    isMulti
                    value={_selectedUserLists}
                    onChange={handleChangeUserLists}
                  />

                  <InputLabel sx={{ mt: 1 }}>
                    Select Permitted Students (Optional):
                  </InputLabel>
                  <Select
                    options={_allStudents}
                    isMulti
                    value={_selectedStudents}
                    onChange={handleChangeStudents}
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={_autoSignup}
                        onChange={(event) => handleChangeAutoSignup(event)}
                      />
                    }
                    label="AUTOMATICALLY SIGN THESE STUDENTS UP ON THEIR BEHALF"
                  />
                </>
              )}
            </Container>
          )}
          {_selectedIndex === 1 && (
            <Container sx={{ pl: 0 }}>
              <br />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={_createPasses}
                    onChange={(event) => setCreatePasses(event.target.checked)}
                  />
                }
                label="Create Hall Passes Automatically for this Event"
              />
              <MuiSelect
                fullWidth
                size="small"
                sx={{ mb: 1 }}
                value={_passType}
                onChange={(evt) => setPassType(evt.target.value)}
                disabled={_createPasses === false}
              >
                <MuiMenuItem key="XX" value="XX">
                  -- SELECT PASS TYPE --
                </MuiMenuItem>
                {_passTypes.map((passType) => (
                  <MuiMenuItem key={passType.eid} value={passType.eid}>
                    {passType.name}
                  </MuiMenuItem>
                ))}
              </MuiSelect>

              {_createPasses === true && (
                <Alert severity="warning" sx={{ mb: 1 }}>
                  WARNING: Hall Passes will be automatically created AND
                  APPROVED for the students who sign up for this event. If you
                  select a Pass Type with a maximum number of passes, that limit
                  will be applied to this event.
                </Alert>
              )}
            </Container>
          )}

          {_selectedIndex === 2 && (
            <Container sx={{ pl: 0 }}>
              <br />
              <TeachersSelector
                school={_school}
                jwt={_jwt}
                onChange={onSelectTeachers}
                selectedTeachers={_selectedTeachers}
                label={"Select Proctor(s)"}
              />{" "}
              <InputLabel sx={{ mt: 1 }}>Description</InputLabel>
              <TextField
                margin="dense"
                type="text"
                fullWidth
                size="small"
                onChange={handleChangeDescription}
                placeholder="Optional Field"
                value={_description}
              />
              <InputLabel sx={{ mt: 1 }}>School Location (optional)</InputLabel>
              <Select
                options={_allLocations}
                value={_selectedLocation}
                onChange={handleChangeLocation}
              />
              <InputLabel sx={{ mt: 1 }}>Max # Students</InputLabel>
              <NumericInput
                className="numericInput"
                min={5}
                max={2500}
                value={_maxStudents}
                onChange={(value) => setMaxStudents(value)}
              />
            </Container>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} variant="outlined">Close</Button>
          <Button variant="contained" onClick={onClickSave}>
            SAVE Event
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ManageEvents;
